import { Controller } from "@hotwired/stimulus";
import { getScoreFunctionPreservingOrderInSearch, selectize } from "../../../../scripts/selectizeHelper";

export default class PhonemesPagedListController extends Controller {
    static targets = [
        "language",
        "enabledDisabled",
    ];
       
    readonly languageTarget!: HTMLElement;
    readonly enabledDisabledTarget!: HTMLElement;

    connect() {
        var languageJquery = $(this.languageTarget);
        var forms = languageJquery.closest("form") as JQuery<HTMLFormElement>;
        if (!forms || forms.length !== 1) throw new Error("Cannot find enclosing form.")
        var form = forms[0];

        selectize(languageJquery, {
            onChange: () => {
                form.requestSubmit();
            },
            score: getScoreFunctionPreservingOrderInSearch
        });

        this.enabledDisabledTarget.addEventListener("change", () => {
            form.requestSubmit();
        });
    }
}